import React from "react";
// Provide real social links...
const Social = () => {
  return (
    <div className="home_social">
      <a href="https://instagram.com/" className="home_social-icon" target="_blank">
      <i className="uil uil-instagram"></i>
      </a>
      <a href="" className="home_social-icon" target="_blank">
      <i className="uil uil-snapchat-alt"></i>
      </a>
      <a href="" className="home_social-icon" target="_blank">
      <i className="uil uil-github-alt"></i>
      </a>
    </div>
  );
};

export default Social;
